export default __webpack_public_path__ + "static/media/title_en_sp.f0b03a9a.png";